
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Um den «Schlummertrunk» ranken sich viele Missverständnisse. Klar ist: ein, zwei Gläser Wein oder Bier können als Einschlafhilfe dienen – aber zu einem hohen Preis. Wer getrunken hat, wird müde, schläft rascher ein und ruht ein paar Stunden lang ungestört. `}<M mdxType="M">{`Aber: Die Bettschwere verkehrt sich spätestens in der zweiten Nachthälfte in Unruhe.`}</M>{` Etliche Studien haben gezeigt, dass Menschen nach Alkoholgenuss in der zweiten Nachthälfte häufiger aufwachen. Ursache ist, dass der Alkohol dann bis zu dem Level abgebaut ist, an dem er stimulierend wirkt. Gleichzeitig reduziert Alkohol – zumindest bei denen, die mehr als ein bis zwei Drinks intus haben – die REM-Schlafphasen. Dies sind die Nachtphasen, in denen Träume vorkommen. Ein Mangel an REM-Schlaf kann Konzentration, Gedächtnisleistungen und die motorischen Fähigkeiten negativ beeinflussen.`}<br /><br />{`
In höheren Dosen behindert Alkohol auch die Atmung: Er kann Nichtschnarcher in Schnarcher verwandeln. Schnarcher wiederum können Schlafapnoen entwickeln. Dies sind Atemaussetzer, die den Schlaf unruhiger und weniger erholsam machen. Hinzu kommt: Wer grössere Mengen trinkt, verstärkt zugleich seinen Harndrang und seinen Durst, da Alkohol dem Körper Wasser entzieht. Alles in allem verbessert Alkohol den Schlaf nicht – im Gegenteil.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;